module.exports = __webpack_public_path__ + "resources/img/bg_solution_main1.5aa60f2eabec5f4445796e4fcc4c19a7.png";